<template>
 <!-- 发件人地址库弹框  -->
 <div class="dialogBox">
     	<el-dialog title="Product info" :visible.sync="dialogTableVisible" :close-on-click-modal="false" @close="clkClose" custom-class="borRad10" width="650px">
          <div class="marBot10">
              <label><span class="colRed">*</span><b>Commodity：</b></label>
              <label><input v-model="searchInput" type="text" class="inputLine" style="width:50%;" placeholder="Please enter the commodity name for query" /></label>
              <label class="marL20"><a class="butChoose" @click="clkSearchBtn(searchInput)">Search</a></label>
         </div>
         <table border="0" cellspacing="0" cellpadding="0" class="listTable marTop10">
            <tr>
              <th width="6%"><p><el-checkbox v-model="chkAll" @change="chgProAll" :disabled="isDisabled"></el-checkbox></p></th>
              <th width="35%"><p>Commodity</p></th>
              <th width="20%"><p>Materies</p></th>
              <th width="20%"><p>Use</p></th>
              <th><p>HS CODE</p></th>
            </tr>
            <tr v-for="(item,index) in porductList" :key="index" v-if="porductList.length > 0">
              <td><el-checkbox v-model="item.chkItem" @change="chgProItem"></el-checkbox></td>
              <td>{{item.EnglishName}}</td>              
              <td>{{item.Material}}</td>
              <td>{{item.Purpose}}</td>
              <td>{{item.CustomsCode}}</td>
              <!-- <td>
                <a class="butChoose" @click="chooseAdd(item)">选择</a>
              </td> -->
            </tr>
            <tr v-if="porductList.length <= 0">
              <td colspan="5" style="height:50px;"> <span class="colGray9">No results</span> </td>
            </tr>
         </table>
         <span center slot="footer" class="dialog-footer">
            <el-button @click="dialogTableVisible = false">Cancel</el-button>
            <el-button type="primary" @click="clkConfirmBtn">Confirm</el-button>
          </span>
      </el-dialog>
  </div>
        
</template>

<script type="text/ecmascript-6">
   import Vue from 'vue'  
  import {getCookie} from '../../../ask/cookiejs'
  import {post,fetch,Del,put} from '../../../ask/axios' 
  // import bus from '../../../ask/eventBus' 
  export default {
     data (){
        return {
        api: {
          url: "",
          param: "",
          data:"",
          response: {},
          message: ""
        },

        //收发件人信息
         dialogTableVisible:false,
         searchInput:'',
         isDisabled:false,

         porductList:[],
         chkAll:false, //全选
         isClk:false, //是否高亮显示选择勾选

      }
     },

    created(){ //创建后

    },
    mounted(){ //载入dom后周期函数
      
    },
    watch:{//监听函数变化

    },
    computed:{//计算属性
    
 
     },

     //方法
    methods: {

      //-------------------------------收发件人，通知人信息---------------------------------//
      clkClose(){
        this.chkAll=false
        this.searchInput=''
      },
      //
      clkDialog(){
        this.searchPorduct();
        this.dialogTableVisible=true
      },

      // },

      //产品信息查询接口
     clkSearchBtn(val){
         this.searchPorduct(val)
     },

    searchPorduct(val){
      let that=this
      that.api.param={
        EnglishName:val
      }
      that.api.url=that.$api02 + '/api/EbayCustomer/BasProduct/Query';
      post(that.api.url,that.api.param).then(function (res) {
        that.porductList=res.Results

        that.porductList.forEach(e =>{
          Vue.set(e,'chkItem',false)
        })
        if(that.porductList.length <=0 ){
          that.isDisabled=true
        }else{
          that.isDisabled=false
        }
      })
    }, 

    
      //全选
      chgProAll(){
         if(this.chkAll==true){
           this.porductList.forEach(e =>{
               Vue.set(e,'chkItem',true)
            })
            this.isClk=true
         }else if(this.chkAll==false){
           this.porductList.forEach(e =>{
               Vue.set(e,'chkItem',false)
            })
            this.isClk=false
         }
      },
      //单选
      chgProItem(item){
        let isTrue=true
        let chkItemArr=[]
         this.porductList.forEach(e =>{
           chkItemArr.push(e.chkItem)
             if(e.chkItem==false){
                isTrue=false
                return false
              }
          })
         if(isTrue==false){
           this.chkAll=false
         }

         if($.inArray(true, chkItemArr) > -1){ //‘>-1’，true包含在数组内, ‘== -1’,不包含在数组内
            this.isClk=true //其中有一个勾选了，选择按钮高亮显示
         }else{
           this.isClk=false 
         }
    
      },

     //确定按钮
    clkConfirmBtn(){
        if(this.isClk==true){
           let itemArr=[]
          this.porductList.forEach(e =>{
              if(e.chkItem==true){
                itemArr.push(e)
              }
            })
          //console.log('nameEn  '  + JSON.stringify(itemArr))
          // console.log('nameEnObj  '  + nameEnObj)
          this.$emit('productMsgEvent',itemArr)
          this.dialogTableVisible=false;
          this.searchInput=''
        }
      },
     },
  }

</script>

<style type="text/css" rel="stylesheet" scoped="scoped">
@import "../../../assets/css/popupBox.css";

.linkBlue{color:#fff;border:1px solid #004FB1;border-radius:30px;padding:4px 10px;background:#004FB1;}
.linkGray{color:#999;border:1px solid #ddd;border-radius:30px;padding:4px 10px;background:#f0f0f0;cursor:default;}

</style>



// WEBPACK FOOTER //
// src/components/userCenter/public/productInfoBox.vue